import { ConversionError } from '../../error/ConversionError';
import { AbstractIOConverter } from '../module';
/**
 * Convert and validate date time strings
 *
 * @example
 * '2019-12-29T12:00:00' => '2019-12-29T12:00:00Z'
 */
export class UTCDateTimeStringToDateString extends AbstractIOConverter {
    static toServerFormat(input) {
        // Do not handle null or undefined input
        if (input === null) {
            return null;
        }
        if (typeof input === 'undefined') {
            return undefined;
        }
        // Determine if we're handling a date or ISO string. In any case, set the correct date.
        let date;
        if (typeof input === 'string') {
            date = new Date(input);
            if (isNaN(date.getTime())) {
                throw new ConversionError(`Can't convert an invalid date to a date time string!`, 'toServer');
            }
        }
        else {
            date = input;
        }
        // Format for backend
        return date.toISOString();
    }
    static toClientFormat(input) {
        // Do not handle null or undefined input
        if (input === null || typeof input === 'undefined') {
            return input;
        }
        // If string does not end with a timezone indicator (Z, +00:00 or -00:00)
        if (input.trim().match(/(((-|\+)\d{2}:\d{2})|Z)$/) === null) {
            input = `${input}Z`; // Force UTC
        }
        // Format for frontend
        const date = Date.parse(input);
        if (isNaN(date)) {
            // If date is invalid, return today
            return new Date().toISOString();
        }
        return new Date(date).toISOString();
    }
}
